import { ERROR_MESSAGE_500, ERROR_STATUS_500 } from "./const";

/*
 * Errorを継承して、新しいエラーを作る
 * status属性にHTTPのステータスコードが格納できるように
 */
export class HttpError extends Error {
  public readonly status: number;

  public readonly response?: Response;

  public constructor(status: number, message?: string, response?: Response) {
    super(message);
    this.status = status;
    this.response = response;
  }
}

export const handleHttpError = (error: unknown): HttpError => {
  let errorStatus = ERROR_STATUS_500;
  let errorMessage = ERROR_MESSAGE_500;
  if (typeof error === "object" && error !== null) {
    if ("status" in error && typeof error.status === "number") {
      errorStatus = error.status;
    }
    if ("message" in error && typeof error.message === "string") {
      errorMessage = error.message;
    }
  }
  return new HttpError(errorStatus, errorMessage);
};
